/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { EducabotColourField } from './customBlocks/colourPickerField';

// Los hex tienen que coincidir con CAMERA_COLOURS del generador.
const ROJO = '#cc0000';
const VERDE = '#33ff33';
const AMARILLO = '#ffff00';
const AZUL = '#000099';

const cameraImage = () => new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/camera.svg`, options.blockWidth, options.blockHeight);

// El color va en un bloque sombra redondo enchufado a una entrada de valor (como
// colour_bhoot en outputsBlocks) para que el cuadro tome la forma de píldora.
const defineColourShadow = (type, colours, titles) => {
  Blockly.Blocks[type] = {
    init: function () {
      this.setOutputShape(options.SHAPES.ROUND);
      this.appendDummyInput().appendField(
        new EducabotColourField(colours[0], undefined, {
          colourOptions: colours,
          colourTitles: titles(),
          columns: colours.length,
        }),
        'COLOR',
      );
      this.setOutput(true, 'CameraColour');
      this.setTooltip(Blockly.Msg.LANG_Color);
      this.setColour(colors.COLOUR_CAMERA);
    },
  };
};

defineColourShadow('CAMERA_colour', [ROJO, VERDE, AMARILLO, AZUL], () => [
  Blockly.Msg.LANG_CAMERA_COLOUR_RED,
  Blockly.Msg.LANG_CAMERA_COLOUR_GREEN,
  Blockly.Msg.LANG_CAMERA_COLOUR_YELLOW,
  Blockly.Msg.LANG_CAMERA_COLOUR_BLUE,
]);

defineColourShadow('CAMERA_colour_position', [ROJO, VERDE], () => [
  Blockly.Msg.LANG_CAMERA_COLOUR_RED,
  Blockly.Msg.LANG_CAMERA_COLOUR_GREEN,
]);

const appendHeader = (block) => block.appendDummyInput('image')
  .appendField(cameraImage())
  .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);

const initBoolean = (block) => {
  block.setOutputShape(options.SHAPES.HEXAGONAL);
  block.setColour(colors.COLOUR_CAMERA);
  appendHeader(block);
  block.setInputsInline(true);
  block.setOutput(true, 'Boolean');
};

Blockly.Blocks.CAMERA_face_detected = {
  init: function () {
    initBoolean(this);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CAMERA_FACE_DETECTED);
    this.setTooltip(Blockly.Msg.LANG_CAMERA_FACE_DETECTED_TOOLTIP);
  },
};

Blockly.Blocks.CAMERA_color_detected = {
  init: function () {
    initBoolean(this);
    this.appendValueInput('COLOR')
      .setCheck('CameraColour')
      .appendField(Blockly.Msg.LANG_CAMERA_COLOR_DETECTED);
    this.setTooltip(Blockly.Msg.LANG_CAMERA_COLOR_DETECTED_TOOLTIP);
  },
};

Blockly.Blocks.CAMERA_shape_detected = {
  init: function () {
    initBoolean(this);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_CAMERA_SHAPE_DETECTED)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_CAMERA_SHAPE_SQUARE, 'CAM_CUADRADO'],
        [Blockly.Msg.LANG_CAMERA_SHAPE_TRIANGLE, 'CAM_TRIANGULO'],
        [Blockly.Msg.LANG_CAMERA_SHAPE_CIRCLE, 'CAM_CIRCULO'],
      ]), 'SHAPE');
    this.setTooltip(Blockly.Msg.LANG_CAMERA_SHAPE_DETECTED_TOOLTIP);
  },
};

Blockly.Blocks.CAMERA_motion_detected = {
  init: function () {
    initBoolean(this);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CAMERA_MOTION_DETECTED);
    this.setTooltip(Blockly.Msg.LANG_CAMERA_MOTION_DETECTED_TOOLTIP);
  },
};

Blockly.Blocks.CAMERA_color_position = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_CAMERA);
    appendHeader(this);
    this.appendValueInput('COLOR')
      .setCheck('CameraColour')
      .appendField(Blockly.Msg.LANG_CAMERA_COLOR_POSITION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_CAMERA_COLOR_POSITION_AXIS)
      .appendField(new Blockly.FieldDropdown([
        ['x', 'CAM_EJE_X'],
        ['y', 'CAM_EJE_Y'],
        ['z', 'CAM_EJE_Z'],
      ]), 'AXIS');
    this.setInputsInline(true);
    this.setOutput(true, 'Number');
    this.setTooltip(Blockly.Msg.LANG_CAMERA_COLOR_POSITION_TOOLTIP);
  },
};
